import lodash from "lodash";
import { createColumnInput } from "../../../../../components/table/c-table.logic";
import i18n from "../../../../../i18n";
import store from "../../../../../store";
import { createButtonCreate } from "../../../../../utils/button";
import { onClickDeleteAllClient } from "../../../../../utils/form";
import { createLoading } from "../../../../../utils/loading";
import { createManageDelete, createPage } from "../../../../../utils/page";

export const { isLoading, setIsLoading } = createLoading();

export const actionPrefix = "resource/v1/transaction/informProductQty";

export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria });

export const createColumns = () => {
    const columns = [];
    columns.push(
        createColumnInput({ title: () => i18n.global.t("model.hazMainSubStance.refSubStance"), dataIndex: "refSubStance.name", width: 200 })
    );
    columns.push(
        createColumnInput({
            title: () => i18n.global.t("model.hazMainSubStance.qty"),
            dataIndex: "qty",
            dataIndexValue: ({ record }) => record.qty !== undefined && record.qty !== null ? record.qty : <span><span>{`${record.microAnalysisQty1}x${record.microAnalysisQty2}`}</span><sup>{`${record.microAnalysisQty3}`}</sup></span>,
            customRender: ({ record, column }) => <div>{column.dataIndexValue({ record })}</div>,
            align: "center",
            width: 100,
            allowPrecision: true,
            inputProp: () => ({ allowPrecision: false })
        })
    );
    columns.push(
        createColumnInput({ title: () => i18n.global.t("model.hazMainSubStance.refUnit"), dataIndex: "refUnit.value", align: "center", width: 100 })
    );
    return columns;
};

export const initData = ({ props, data }) => {
    const { menuContext, viewOnly, itemsKey, canCreate, canDelete } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    data.columns = createColumns({ props, data });
    data.page = createPage({ data: items });
    data.tableOptions = { search: { activeKey: null } };
    data.manages = [
        createManageDelete({
            menuContext,
            visible: () => (viewOnly ? false : canDelete),
            onClick: ({ rowSelection }) => {
                onClickDeleteAllClient({ rowSelection, useForm, items, key: itemsKey });
                data.page.page = 0;
            }
        })
    ];
    data.manageExtras = [
        {
            render: () => createButtonCreate({ onClick: () => items.push({}) }),
            visible: () => (viewOnly ? false : canCreate)
        }
    ];
    data.rowActions = [];
    fetchData({ props, data }).then(page => items.push(...page.data));
};

export const fetchData = ({ props }) => {
    const { fetchCriteria } = props;
    if (!fetchCriteria || fetchCriteria.fetched) {
        return Promise.resolve({ data: [] });
    }
    fetchCriteria.fetched = true;
    setIsLoading(true);
    return callSearch({ criteria: fetchCriteria }).finally(() => setIsLoading(false));
};
